import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, Menu, X, ChevronDown, User, Bell, MessageSquare } from "lucide-react";
import { topNavLinks, brand } from "../mock";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const doSearch = (e) => {
    e.preventDefault();
    navigate(`/?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <header className="w-full sticky top-0 z-50">
      {/* Top utility bar */}
      <div className="bg-[#005f6b] text-white text-xs hidden md:block">
        <div className="max-w-[1200px] mx-auto px-4 h-8 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link to="/help" className="hover:underline">Help</Link>
            <Link to="/faq" className="hover:underline">FAQ</Link>
            <Link to="/qa" className="hover:underline">{brand.name} Q&amp;A</Link>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/subscribe" className="hover:underline flex items-center gap-1"><Bell size={12}/> Subscribe</Link>
            <Link to="/signin" className="hover:underline flex items-center gap-1"><User size={12}/> Sign in</Link>
            <Link to="/signup" className="hover:underline">Sign up</Link>
          </div>
        </div>
      </div>

      {/* Main header */}
      <div className="bg-[#007a8a] text-white">
        <div className="max-w-[1200px] mx-auto px-4 h-[64px] flex items-center gap-4">
          <button className="md:hidden text-white" onClick={() => setOpen(!open)} aria-label="menu">
            {open ? <X size={22}/> : <Menu size={22}/>}
          </button>
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <div className="w-9 h-9 bg-[#f5a623] rounded-md flex items-center justify-center font-black text-[#003844]">
              RU
            </div>
            <div className="hidden sm:block leading-tight">
              <div className="font-bold text-[15px]">{brand.name}</div>
              <div className="text-[10px] opacity-80">{brand.domain}</div>
            </div>
          </Link>

          <form onSubmit={doSearch} className="flex-1 max-w-[640px] mx-auto">
            <div className="flex bg-white rounded-md overflow-hidden">
              <input
                type="text"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Search company by name"
                className="flex-1 px-3 py-2 text-sm text-gray-800 outline-none"
              />
              <button
                type="submit"
                className="bg-[#f5a623] hover:bg-[#e69612] transition-colors px-4 flex items-center justify-center text-[#003844]"
                aria-label="search"
              >
                <Search size={18} strokeWidth={2.5}/>
              </button>
            </div>
          </form>

          <div className="hidden lg:flex items-center gap-1">
            <Link to="/signin" className="text-sm hover:bg-white/10 px-3 py-1.5 rounded-md">Sign in</Link>
            <Link to="/signup" className="text-sm bg-[#f5a623] hover:bg-[#e69612] text-[#003844] font-semibold px-3 py-1.5 rounded-md">Sign up</Link>
          </div>
        </div>

        {/* Secondary nav */}
        <div className="border-t border-white/10 hidden md:block">
          <div className="max-w-[1200px] mx-auto px-4 h-10 flex items-center gap-1 overflow-x-auto text-sm">
            {topNavLinks.map((l) => (
              <Link
                key={l.label}
                to={l.href}
                className="px-3 py-1.5 rounded hover:bg-white/10 whitespace-nowrap flex items-center gap-1"
              >
                {l.label}
                <ChevronDown size={14}/>
              </Link>
            ))}
            <Link to="/collective-complaints" className="px-3 py-1.5 rounded hover:bg-white/10 whitespace-nowrap flex items-center gap-1 ml-auto">
              <MessageSquare size={14}/> Collective Complaints
            </Link>
          </div>
        </div>

        {open && (
          <div className="md:hidden bg-[#005f6b] px-4 py-3 space-y-2 text-sm">
            {topNavLinks.map((l) => (
              <Link key={l.label} to={l.href} onClick={() => setOpen(false)} className="block py-1.5 hover:underline">{l.label}</Link>
            ))}
            <hr className="border-white/10"/>
            <Link to="/signin" onClick={() => setOpen(false)} className="block py-1.5">Sign in</Link>
            <Link to="/signup" onClick={() => setOpen(false)} className="block py-1.5">Sign up</Link>
          </div>
        )}
      </div>
    </header>
  );
}
